export enum BioSampleErrorCodeType {
  DUPLICATE_SAMPLE = 'DUPLICATE_SAMPLE',
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  UNEXPECTED = 'UNEXPECTED',
  SAMPLE_NOT_FOUND = 'SAMPLE_NOT_FOUND',
}
